import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import AnonymousRequired from 'components/AnonymousRequired';

import Logo from 'components/Logo';
import {AcceptInvitationForm} from './components';

import {fetchUserByInvitationKey, selectInvitationUser} from 'ducks/auth';

import './styles.css';

class AcceptInvitation extends React.Component<any> {
  componentDidMount() {
    const {key} = this.props.match.params;
    this.props.fetchUserByInvitationKey({key});
  }

  render() {
    const {email} = this.props;
    const {key} = this.props.match.params;

    return (
      <div className="AcceptInvitation">
        <div className="content">
          <Logo white={true} />
          <AcceptInvitationForm email={email} token={key} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    email: _.get(selectInvitationUser(state), 'email')
  };
};

const mapDispatchToProps = {
  fetchUserByInvitationKey
};

export default connect(mapStateToProps, mapDispatchToProps)(
  AnonymousRequired(AcceptInvitation)
);
